@if (paymentTerm) {
<div

  [formGroup]="paymentTermForm">
  <div formArrayName="customDates">
    @for (customDate of customDates.controls; track customDate; let i = $index) {
<se-fe-grid

      seFeGridOpts="loose">
      <se-fe-grid-cell seFeGridOpts="1/1@mobile">
        <se-fe-grid>
          <se-fe-grid-cell seFeGridOpts="2/3@mobile 3/4@tablet">
            <strong
              [translate]="'PAYMENT_TERMS_SELECTOR.TITLES.installment'"
              [translateParams]="{ index: i + 1 }"></strong>
            <se-fe-grid
              seFeGridOpts="baseline"
              class="custom-date-section">
              <se-fe-grid-cell seFeGridOpts="shrink@mobile">
                <small [translate]="'PAYMENT_TERMS_SELECTOR.due'"></small>
              </se-fe-grid-cell>
              <se-fe-grid-cell seFeGridOpts="grow@mobile">
                <se-fe-datepicker
                  seFeDataLabel=""
                  seFeDataHelpText="Month, day, year"
                  [seFeDataDateRangeIcon]="true"
                  [formControlName]="i"
                  [seFeDataYearRange]="{ future: 5, past: 0 }"
                  [seFeDataExcludeDates]="excludeDates"
                  (dateChange)="emitDates(true)"></se-fe-datepicker>
              </se-fe-grid-cell>
            </se-fe-grid>
            @if (customDate.invalid && (customDate.dirty || customDate.touched)) {
<se-fe-grid>
              <se-fe-grid-cell seFeGridOpts="1/1@mobile">
                <se-fe-alert seFeDataType="error">
                  @if (customDate.hasError('required')) {
<p

                    [translate]="'PAYMENT_TERMS_SELECTOR.CUSTOM_DATES_SELECTOR.ERRORS.required'"></p>
}
                  @if (customDate.hasError('dates_not_in_order') && !customDate.hasError('required')) {
<p

                    [translate]="'PAYMENT_TERMS_SELECTOR.CUSTOM_DATES_SELECTOR.ERRORS.dates_not_in_order'"
                    [translateParams]="{ index: i }"></p>
}
                  @if (customDate.hasError('invalid_future_date') && !customDate.hasError('required')) {
<p

                    [translate]="'PAYMENT_TERMS_SELECTOR.CUSTOM_DATES_SELECTOR.ERRORS.invalid_future_date'"></p>
}
                  @if (customDate.hasError('past_date_selected') && !customDate.hasError('required')) {
<p

                    [translate]="'PAYMENT_TERMS_SELECTOR.CUSTOM_DATES_SELECTOR.ERRORS.past_date_selected'"></p>
}
                </se-fe-alert>
              </se-fe-grid-cell>
            </se-fe-grid>
}
          </se-fe-grid-cell>
          @if (saleType === 'order') {
<se-fe-grid-cell

            seFeGridOpts="1/3@mobile 1/4@tablet">
            <se-fe-grid seFeGridOpts="right">
              <se-fe-grid-cell seFeGridOpts="shrink@mobile">
                <strong>{{ this.previewPercentages[i] }}%</strong>
              </se-fe-grid-cell>
            </se-fe-grid>
          </se-fe-grid-cell>
}
          @if (saleType === 'invoice') {
<se-fe-grid-cell

            seFeGridOpts="1/3@mobile 1/4@tablet">
            <se-fe-grid seFeGridOpts="right">
              <se-fe-grid-cell seFeGridOpts="shrink@mobile">
                <strong>{{ this.installments[i].amount | currency }}</strong>
              </se-fe-grid-cell>
            </se-fe-grid>
          </se-fe-grid-cell>
}
        </se-fe-grid>
      </se-fe-grid-cell>
    </se-fe-grid>
}
  </div>
</div>
}
